import { Button, Icon } from 'bold-ui'
import { BadgeNotificacao } from 'components/notificacao/BadgeNotificacao'
import { useMarcarNotificacaoComoLidaMutation } from 'graphql/hooks.generated'
import { TipoTopicoNotificacaoEnum } from 'graphql/types.generated'
import { useNotificacaoStatus } from 'hooks/notificacao/useNotificacaoStatus'
import { useState } from 'react'

import { ListaRegulacaoModal } from '../modal/ListaRegulacaoModal'
import { ListaRegulacaoTableItem } from '../model-regulacao'

interface ListaRegulacaoTableActionProps {
  item: ListaRegulacaoTableItem
}

export const ListaRegulacaoTableAction = (props: Readonly<ListaRegulacaoTableActionProps>) => {
  const { item } = props
  const [modalOpen, setModalOpen] = useState(false)

  const [marcarNotificacaoComoLida] = useMarcarNotificacaoComoLidaMutation()

  const handleModalOpen = () => {
    setModalOpen(true)
    marcarNotificacaoComoLida({
      variables: {
        codigoExterno: item.id,
        tipoTopico: TipoTopicoNotificacaoEnum.REGULACAO_ASSISTENCIAL,
      },
    })
  }

  const notificar = useNotificacaoStatus(TipoTopicoNotificacaoEnum.REGULACAO_ASSISTENCIAL, item.id)

  return (
    <>
      <Button onClick={handleModalOpen} skin='ghost' size='small'>
        <BadgeNotificacao value={notificar} type='small' color='blue'>
          <Icon icon='zoomOutline' />
        </BadgeNotificacao>
      </Button>

      {modalOpen && <ListaRegulacaoModal item={item} handleClose={() => setModalOpen(false)} />}
    </>
  )
}
